import React, { useState, useEffect } from 'react';
import { colors, radius, fonts } from '../theme';
import { community } from '../api';

export function CommunityPage() {
  const [tab, setTab] = useState<'feed' | 'contests' | 'events'>('feed');
  const [posts, setPosts] = useState<any[]>([]);
  const [contests, setContests] = useState<any[]>([]);
  const [events, setEvents] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [newPost, setNewPost] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    community.feed({ page, limit: 20 }).then(r => setPosts(r.data)).catch(() => {});
    community.contests(true).then(r => setContests(r.data)).catch(() => {});
    community.events(true).then(r => setEvents(r.data)).catch(() => {});
  }, [page]);

  const handlePost = async () => {
    if (!newPost.trim()) return;
    setBusy(true);
    try {
      await community.createPost({ content: newPost, post_type: 'text' });
      setNewPost('');
      setMsg('Post publié !');
      community.feed({ page: 1, limit: 20 }).then(r => setPosts(r.data));
    } catch { setMsg('Erreur'); }
    setBusy(false);
    setTimeout(() => setMsg(''), 3000);
  };

  const handleLike = async (id: number) => {
    try {
      await community.likePost(id);
      community.feed({ page, limit: 20 }).then(r => setPosts(r.data));
    } catch {}
  };

  const handleRegister = async (id: number) => {
    try {
      await community.registerEvent(id);
      setMsg('Inscription confirmée !');
      community.events(true).then(r => setEvents(r.data));
    } catch (err: any) {
      setMsg(err.response?.data?.detail || 'Erreur');
    }
    setTimeout(() => setMsg(''), 3000);
  };

  const handleCancel = async (id: number) => {
    try {
      await community.cancelEvent(id);
      community.events(true).then(r => setEvents(r.data));
    } catch {}
  };

  return (
    <div>
      <h2 style={{ color: colors.gold, fontSize: 24, marginBottom: 8 }}>Communauté</h2>

      {msg && <div style={{ color: msg.includes('!') ? colors.success : colors.error, background: `${msg.includes('!') ? colors.success : colors.error}15`, padding: 12, borderRadius: radius.sm, marginBottom: 16, fontSize: 14 }}>{msg}</div>}

      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {(['feed', 'contests', 'events'] as const).map(t => (
          <button key={t} onClick={() => setTab(t)} style={tab === t ? tabActive : tabStyle}>
            {t === 'feed' ? '📰 Fil' : t === 'contests' ? '🏆 Concours' : '🎉 Événements'}
          </button>
        ))}
      </div>

      {/* FEED */}
      {tab === 'feed' && (
        <div>
          <div style={{ background: colors.card, borderRadius: radius.md, padding: 16, border: `1px solid ${colors.border}`, marginBottom: 20 }}>
            <textarea value={newPost} onChange={e => setNewPost(e.target.value)} placeholder="Quelle est votre expérience au Siam ?" style={{ width: '100%', padding: 12, background: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: radius.sm, color: colors.text, fontSize: 14, minHeight: 60, resize: 'vertical', fontFamily: fonts.body, boxSizing: 'border-box' }} />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
              <button onClick={handlePost} disabled={busy || !newPost.trim()} style={btnPrimary}>{busy ? '...' : 'Publier'}</button>
            </div>
          </div>
          {posts.map((p: any) => (
            <div key={p.id} style={{ background: colors.card, borderRadius: radius.md, padding: 16, border: `1px solid ${colors.border}`, marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <span style={{ color: colors.gold, fontWeight: 600 }}>{p.user_name || 'Anonyme'}</span>
                <span style={{ color: colors.textMuted, fontSize: 12 }}>{new Date(p.created_at).toLocaleDateString('fr-FR')}</span>
              </div>
              <p style={{ color: colors.text, fontSize: 15, margin: '0 0 12 0' }}>{p.content}</p>
              {p.media_url && <img src={p.media_url} alt="" style={{ width: '100%', borderRadius: radius.sm, marginBottom: 12 }} />}
              <button onClick={() => handleLike(p.id)} style={{ background: 'none', border: 'none', color: p.is_liked ? colors.error : colors.textMuted, cursor: 'pointer', fontSize: 14, fontFamily: fonts.body }}>
                {p.is_liked ? '❤️' : '🤍'} {p.likes_count}
              </button>
            </div>
          ))}
          {posts.length === 0 && <p style={{ color: colors.textMuted, textAlign: 'center' }}>Aucun post pour le moment</p>}
        </div>
      )}

      {/* CONTESTS */}
      {tab === 'contests' && (
        <div>
          {contests.map((c: any) => (
            <div key={c.id} style={{ background: colors.card, borderRadius: radius.md, padding: 20, border: `1px solid ${colors.gold}40`, marginBottom: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                <span style={{ fontSize: 32 }}>🏆</span>
                <div>
                  <h3 style={{ color: colors.gold, fontSize: 18, margin: 0 }}>{c.name}</h3>
                  <span style={{ color: colors.textMuted, fontSize: 12, textTransform: 'uppercase' }}>{c.contest_type}</span>
                </div>
              </div>
              {c.prize_description && <p style={{ color: colors.text, fontSize: 14 }}><strong>Récompense :</strong> {c.prize_description}</p>}
              <p style={{ color: colors.textMuted, fontSize: 13 }}>Du {new Date(c.start_date).toLocaleDateString('fr-FR')} au {new Date(c.end_date).toLocaleDateString('fr-FR')}</p>
            </div>
          ))}
          {contests.length === 0 && <p style={{ color: colors.textMuted, textAlign: 'center' }}>Aucun concours actif</p>}
        </div>
      )}

      {/* EVENTS */}
      {tab === 'events' && (
        <div>
          {events.map((ev: any) => (
            <div key={ev.id} style={{ background: colors.card, borderRadius: radius.md, padding: 20, border: `1px solid ${colors.border}`, marginBottom: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <h3 style={{ color: colors.text, fontSize: 18, margin: '0 0 4 0' }}>{ev.title}</h3>
                  <p style={{ color: colors.textMuted, fontSize: 13, margin: 0 }}>{ev.description}</p>
                  <div style={{ color: colors.gold, fontSize: 14, marginTop: 8 }}>
                    {new Date(ev.date).toLocaleDateString('fr-FR')} {ev.start_time && `à ${ev.start_time}`}
                    {ev.is_members_only && ' 🔒 Membres uniquement'}
                  </div>
                  <div style={{ color: colors.textMuted, fontSize: 12, marginTop: 4 }}>
                    {ev.attendees_count}/{ev.max_attendees || '∞'} participants
                    {ev.is_free ? ' • Gratuit' : ' • Sur réservation'}
                  </div>
                </div>
                <div>
                  {ev.is_registered ? (
                    <button onClick={() => handleCancel(ev.id)} style={{ ...btnSmall, color: colors.error, borderColor: colors.error }}>Annuler</button>
                  ) : (
                    <button onClick={() => handleRegister(ev.id)} style={{ ...btnSmall, background: colors.gold, color: colors.bg, borderColor: colors.gold }}>S inscrire</button>
                  )}
                </div>
              </div>
            </div>
          ))}
          {events.length === 0 && <p style={{ color: colors.textMuted, textAlign: 'center' }}>Aucun événement à venir</p>}
        </div>
      )}
    </div>
  );
}

const btnPrimary: React.CSSProperties = {
  padding: '10px 24px', background: colors.gold, color: colors.bg, border: 'none',
  borderRadius: radius.sm, fontSize: 14, fontWeight: 'bold', cursor: 'pointer', fontFamily: fonts.body,
};

const btnSmall: React.CSSProperties = {
  padding: '6px 14px', background: 'transparent', color: colors.gold,
  border: `1px solid ${colors.gold}`, borderRadius: radius.sm, fontSize: 13, cursor: 'pointer', fontFamily: fonts.body,
};

const tabStyle: React.CSSProperties = {
  padding: '8px 18px', background: colors.card, color: colors.textMuted,
  border: `1px solid ${colors.border}`, borderRadius: 20, cursor: 'pointer', fontSize: 13, fontFamily: fonts.body,
};

const tabActive: React.CSSProperties = {
  ...tabStyle, background: colors.gold, color: colors.bg, border: `1px solid ${colors.gold}`, fontWeight: 'bold',
};